export const REVERSED = "reversed";
export const PAID = "paid";
export const PENDING = "pending";
export const SEND_NOTIFICATION = "send_notification";



// WEBPACK FOOTER //
// ./app/modules/Commissions/constants.js